export default "__VITE_PUBLIC_ASSET__da12be34__"